import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { AppManagementService } from '@app/core/services/app/app-management.service';
import { RequestFilterFormViewModel } from '@features/teladoc-events/models/ui/request-filter-form-view-model';
import { CheckboxListComponent, ControlErrorDirective, RadiobuttonListComponent } from '@howdeniberia/core-front';
import { IRequestFormFilterDialogResult } from '@sharedModels/custom/request-form-filter-dialog-result';
import { RequestMapper } from './../../mappers/request-mapper';

@Component({
  selector: 'howden-requests-filter-form-dialog',
  templateUrl: './requests-filter-form-dialog.component.html',
  styleUrls: ['./requests-filter-form-dialog.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatError,
    MatDialogActions,
    MatButton,
    MatIcon,
    RadiobuttonListComponent,
    CheckboxListComponent,
    ControlErrorDirective
  ]
})
export class RequestsFilterFormDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<RequestsFilterFormDialogComponent>>(MatDialogRef);
  private readonly appDataSrv = inject(AppManagementService);

  model: RequestFilterFormViewModel = new RequestFilterFormViewModel();
  mapper: RequestMapper = new RequestMapper();

  ngOnInit(): void {
    this.model = this.mapper.iRequestFrontFilterAppDtoToRequestFilterFormViewModel(
      this.appDataSrv.lastRequestFilter,
      this.appDataSrv.avaliableRegions);
  }

  close(accept: boolean): void {
    const result = {
      ok: accept && this.model.anyValueSet,
      value: this.model
    } as IRequestFormFilterDialogResult;
    this.dialogRef.close(result);
  }

  clean(): void {
    this.model.resetForm();
  }
}
